import Directory from '@src/quince-site-common/src/domains/Directory'

interface IBreadcrumbSchema {
  directory: Directory
}

export const BreadcrumbSchema: React.FC<IBreadcrumbSchema> = ({ directory }) => {
  if (!directory?.paths?.length) return <></>
  const allButLastPath = directory.paths.slice(0, -1)

  const breadcrumbSchema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: allButLastPath.map((path, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: path.displayName,
      item: `https://www.quince.com${path.route}`,
    })),
  }

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
}
